<style lang="scss" scoped>
    .login {
        width: 100%;
        height: 100%;
        background: url("../assets/images/bg.png") no-repeat center center;
        background-size: cover;
        .login-container {
            width: 966px;
            height: 518px;
            background: #fff;
            box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.12);
            border-radius: 24px;
            overflow: hidden;
            .login-container__top {
                height: 363px;
                .login-container__logo-img {
                    width: 160px;
                    height: 160px;
                    background: #1973bf;
                    border-radius: 24px;
                }
                .login-container__info {
                    width: 320px;
                    margin-right: 120px;
                    .login-container__info-btn {
                        width: 320px;
                        background: linear-gradient(90deg, rgba(58, 146, 220, 1) 0%, rgba(25, 115, 191, 1) 100%);
                        margin-top: 40px;
                        &:hover {
                            color: #fff;
                        }
                    }
                }
            }
            .login-container__bottom {
                background: #393636;
                height: 155px;
                color: #fff;
                .login-container__bottom-item {
                    height: 100%;
                    .yellow {
                        color: #d8cb98;
                    }
                    .iconfont {
                        font-size: 44px;
                        &.icon-chaxun {
                            font-size: 40px;
                        }
                    }
                }
            }
        }
        .icp-footer {
            position: fixed;
            width: 100%;
            left: 0;
            bottom: 0;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: #262626;
            flex-shrink: 0;
            a {
                font-size: 12px;
                color: #999;
                text-decoration: none;
                &:hover {
                    color: #1d8ce0;
                    text-decoration: underline;
                }
            }
        }
    }
</style>
<template>
    <div class="flex-row-center login">
        <div class="login-container" ref="login">
            <div class="login-container__top flex-row-start">
                <div class="login-container__logo flex-w__1 flex-row-center">
                    <div class="login-container__logo-img">
                        <img src="~@/assets/images/logo.png" />
                    </div>
                </div>
                <div class="login-container__info">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                        <h3 class="text-center text-30 MB-15">欢迎使用</h3>
                        <el-input
                            class="MB-15"
                            placeholder="请输入账号"
                            prefix-icon="text-bold text-18 iconfont icon-user-o"
                            v-model="ruleForm.account"
                            auto-complete="off"
                            clearable
                            @keydown.native="keydown($event)"
                            @keydown.enter.native="handleSubmit"
                        >
                        </el-input>
                        <el-input
                            placeholder="请输入密码"
                            prefix-icon="text-bold text-18 iconfont icon-mima"
                            type="password"
                            v-model="ruleForm.checkPass"
                            auto-complete="off"
                            clearable
                            @keydown.native="keydown($event)"
                            @keydown.enter.native="handleSubmit"
                        >
                        </el-input>
                        <el-button
                            class="login-container__info-btn text-white"
                            @click.native.prevent="handleSubmit"
                            :loading="logining"
                        >
                            登录
                        </el-button>
                    </el-form>
                </div>
            </div>
            <el-row class="login-container__bottom">
                <el-col :span="6" class="login-container__bottom-item text-center flex-column-center">
                    <div class="MB-10 iconfont icon-changjiazhigong"></div>
                    <p class="text-18 yellow">覆盖面广</p>
                    <p class="text-14 MT-5">覆盖全国，真正实现千城万店</p>
                </el-col>
                <el-col :span="6" class="login-container__bottom-item text-center flex-column-center">
                    <div class="MB-10 iconfont icon-huowu"></div>
                    <p class="text-18 yellow">配件齐全</p>
                    <p class="text-14 MT-5">一个小仓相当于一个市场</p>
                </el-col>
                <el-col :span="6" class="login-container__bottom-item text-center flex-column-center">
                    <div class="MB-10 iconfont icon-daohuoqueren"></div>
                    <p class="text-18 yellow">送货上门</p>
                    <p class="text-14 MT-5">在家就能收货</p>
                </el-col>
                <el-col :span="6" class="login-container__bottom-item text-center flex-column-center">
                    <div class="MB-10 iconfont icon-chaxun"></div>
                    <p class="text-18 yellow">查询方便</p>
                    <p class="text-14 MT-5">VIN和OE查配件</p>
                </el-col>
            </el-row>
        </div>

        <el-dialog title="选择登录账号" :visible.sync="loginListVisible" :show-close="false" width="400px" center>
            <el-radio-group v-model="loginId" style="width: 100%;">
                <div v-for="(item, index) in loginList" :key="index" style="display: block; padding: 10px 0;">
                    <el-radio :label="item.id"
                        >【{{ item.shop_name }}】{{ item.username || item.shop_name }} - {{ item.department || "店主" }}</el-radio
                    >
                </div>
            </el-radio-group>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="userLogin()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- loginList -->

        <footer class="icp-footer" v-if="showIcpBox">
			<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" rel="noopener noreferrer">ICP备案号：粤ICP备09172001号-5</a>
		</footer>
    </div>
</template>

<script>
    import { Hover } from "perspective.js";
    import { config } from "@config/network.js";
    export default {
        data() {
            return {
                loginListVisible: false,
                loginList: [],
                loginId: "",
                logining: false,
                ruleForm: {
                    id: "",
                    account: "",
                    checkPass: "",
                },
                rules: {
                    account: [
                        {
                            required: true,
                            message: "请输入账号",
                            trigger: "blur",
                        },
                    ],
                    checkPass: [
                        {
                            required: true,
                            message: "请输入密码",
                            trigger: "blur",
                        },
                    ],
                },
            };
        },
        mounted() {
            new Hover(this.$refs.login, {
                max: 3,
                scale: 1,
                perspective: 700,
                layers: [
                    {
                        multiple: 0.01,
                        reverseTranslate: true,
                    },
                    {
                        multiple: 0.02,
                        reverseTranslate: true,
                    },
                ],
            });
        },
        computed: {
            getShopId() {
                let item = this.loginList.find((v) => v.id == this.loginId);
                return item ? item.shop_id : "";
            },
            showIcpBox() {
                return window.location.origin.indexOf("qp11.cn") !== -1;
            },
        },
        methods: {
            /**
             * 确定登录
             */
            handleSubmit() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.logining = true;
                        var loginParams = {
                            account: this.ruleForm.account.replace(/\s+/g, ""),
                            password: this.ruleForm.checkPass.replace(/\s+/g, ""),
                        };
                        this.$ajax("Admin/Users/loginList", loginParams)
                            .then((data) => {
                                const loginList = data.data.list;
                                this.loginList = loginList;
                                this.loginId = this.loginList[0].id;
                                if (loginList.length > 1) {
                                    this.loginListVisible = true;
                                } else {
                                    this.userLogin();
                                }
                            })
                            .finally(() => {
                                this.logining = false;
                            });
                    } else {
                        return false;
                    }
                });
            },
            userLogin() {
                var loginParams = {
                    account: this.ruleForm.account.replace(/\s+/g, ""),
                    password: this.ruleForm.checkPass.replace(/\s+/g, ""),
                    login_type: 1,
                    shop_id: this.getShopId,
                };
                this.$ajax("Admin/Users/login", { ...loginParams, id: this.loginId })
                    .then((data) => {
                        localStorage.setItem("userInfo", JSON.stringify(data.data || {}));
                        if (data.data) {
                            this.getPrivilegeList();
                            this.$messageOrder._start();
                        }
                    })
                    .finally(() => {
                        this.logining = false;
                    });
            },
            getPrivilegeList() {
                this.$ajax("/Admin/ShopSettings/getGraphicsChoosePermissionList").then((res) => {
                    let resObj = Object.fromEntries(res.data.list.map((item) => [item.type, item]));
                    localStorage.setItem("sepc-privilege", JSON.stringify(resObj));
                });
                this.$ajax("Admin/UserChild/getPrivilegeList", { type: 2 }).then((res) => {
                    this.loginListVisible = false;
                    localStorage.setItem("privilege-list", JSON.stringify(res.data.list));
                    localStorage.setItem("privilege-object", JSON.stringify(res.data.privilege));
                    this.$router.replace("/index");
                });
            },
            keydown(event) {
                if (event.keyCode == 32) {
                    event.returnValue = false;
                }
            },
        },
    };
</script>



// WEBPACK FOOTER //
// Login.vue?382a5947